var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.673,
    d: "M.603 5.74l4.266 4.281c1.415 1.419 3.706 1.419 5.12 0 1.414-1.417 1.415-3.717 0-5.136L5.724.605M3.163 3.173L21.474 21.577",
    transform: "translate(-60 -418) translate(47 405) translate(13.153 13) translate(.999 1)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EEECEB",
    d: "M13.013.213c1.178 1.183-3.408 8.554-10.24 15.408l-2.56-2.57",
    transform: "translate(-60 -418) translate(47 405) translate(13.153 13) translate(.999 1) translate(9.654 1.676)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.673,
    d: "M13.013.213c1.178 1.183-3.408 8.554-10.24 15.408l-2.56-2.57",
    transform: "translate(-60 -418) translate(47 405) translate(13.153 13) translate(.999 1) translate(9.654 1.676)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.673,
    d: "M22.667 1.889L3.04 21.577",
    transform: "translate(-60 -418) translate(47 405) translate(13.153 13) translate(.999 1)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.d51462cd.svg";
export { ForwardRef as ReactComponent };